var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"events"},[(_vm.calendar)?_c('calendar-view'):_c('list-view',{attrs:{"events":_vm.events}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }